import React, { useState } from "react";
import "./popup.scss";
import CommonPopup from "../CommonPopup/commonPopup";

const PoppupProfile = ({ profiledata, setmodaldetails, handleChange, state, profiledatas, handleChanges, handleDelete }) => {

  const [inputValues, setInputValues] = useState(profiledata);

  const handleInputChange = (name, value) => {
    setInputValues({
      ...inputValues,
      [name]: { ...inputValues[name], value: value },
    });
    setmodaldetails({
      ...profiledata,
      [name]: { ...profiledata[name], value: value },
    })
    handleChanges(name, value);
  };

  function handleDeleteClick(val) {
    const updatedData = Object.keys(inputValues)
      .filter(key => key !== val)
      .reduce((acc, key) => {
        acc[key] = profiledata[key];
        return acc;
      },
        {}
      );
    setInputValues(updatedData);
    setmodaldetails(updatedData)
  }


  return (
    <div className="poupfourths_paras">
      <CommonPopup
        handleChange={handleChange}
        handleInputChange={handleInputChange}
        inputValues={inputValues}
        handleDeleteClick={handleDeleteClick}
        type={"profile"}
      />
    </div>
  );
};

export default PoppupProfile;